import { render } from "./CarDetailsCard.vue?vue&type=template&id=61c778b2&scoped=true&ts=true"
import script from "./CarDetailsCard.vue?vue&type=script&lang=ts"
export * from "./CarDetailsCard.vue?vue&type=script&lang=ts"

import "./CarDetailsCard.vue?vue&type=style&index=0&id=61c778b2&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c778b2"]])

export default __exports__